// Metadata comes from OE; no tax-rate guesses or name-based asset merging.
export function priceBasisNote(metadata) {
  return [metadata?.tax_basis_label, metadata?.value_kind_label, metadata?.comparison_label].filter(Boolean).join(' · ');
}
export function seriesPriceMetadata(entries, row, period) {
  const found = (entries || []).find((entry) => entry.reit_code === row.reit_code && (
    row.asset_num != null ? String(entry.asset_num) === String(row.asset_num) : entry.asset_name === row.asset_name
  ));
  return found?.[period];
}
export function escapePriceNote(value) {
  return String(value ?? '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
}
export function isOperationPeriod(key) {
  return /^(?:\d{4}Q[1-4]|\d{4}H[12]|\d{4}A|\d{4}-\d{2})$/.test(key);
}
